"use strict";

exports.__esModule = true;
var _Button = _interopRequireDefault(require("./Button"));
exports.default = _Button.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}